/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Shipping_CarriersInputs */

const vi_nav_shipping_carriers = /** @type {(inputs: Nav_Shipping_CarriersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị vận chuyển`)
};

/**

* @param {Nav_Shipping_CarriersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_shipping_carriers = /** @type {((inputs?: Nav_Shipping_CarriersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Shipping_CarriersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_shipping_carriers(inputs)
});